const zh_cn = {
	'赞助和游戏责任': 'Patrocínio e Responsabilidade no Jogo',
	'产品': 'Produtos',
	'游戏': 'Jogos',
	"announcement": 'Mergulhe na emoção e experimente a diversão dos nossos jogos online hoje mesmo! Explore um mundo de oportunidades onde diversão e recompensas estão ao seu alcance!',
	'排名': 'Classificação',
	"更多的": "Mais",
	"拱廊": "Arcada",
	"撞车游戏": "Jogos de Colisão",
	"钓鱼游戏": "Jogos de Pesca",
	"直播": "Ao vivo",
	"登录": "Log In",
	"注册": 'Registo',
	"选择语言": 'Seleccionar o Idioma',
	"介绍人": 'Referente',
	"账号": "Conta",
	"密码": "Senha",
	// "取款密码": "Senha de retirada",
	"确认密码": "Confirmar a Senha",
	"真实姓名": "Nome verdadeiro",
	"手机号码": "Número de telemóvel",
	"取款密码": "Senha de retirada",
	"验证码": "Código de verificação",
	"请输入密码": "Introduza a senha",
	"请输入验证码": "Introduza o código de verificação",
	"请输入账号": "Por favor insira uma conta",
	"请重新获取验证码": "Por favor, obtenha novamente o código de verificação",
	"正在登录中": "Entrar...",
	"网络异常,请稍后再试": "Erro de rede, tente novamente mais tarde",
	"账号名": "Conta",
	"余额": "Saldo na Carteira",
	"会员中心": "Centro de Membros",
	"网上存款": "Depósito Online",
	"网上提款": "Retirada Online",
	"退出": "Sair",
	"请再次输入密码": "Introduza a senha novamente",
	"请输入姓名": "Por favor indique o seu nome",
	"请输入手机号": "Introduza o seu número de telefone",
	"请输入取款密码": "Indique por favor a senha de retirada",
	"正在注册中": "Registo...",
	"确定": "confirmar",
	"注册成功": "o login foi bem sucedido",
	"热门优惠": "Actividades promocionais",
	"首页": "Página inicial",
	"查看活动": "Ver as Actividades",
	"正在获取活动列表": "Obter a lista de actividades",
	"暂无活动": "Sem actividade de momento",
	"活动详情": "Detalhes do Evento",
	"视讯直播": "Transmissão ao Vivo",
	"直播类型": "Tipo de transmissão ao vivo",
	"热门": "Jogos Populares",
	"推荐": "Jogos Recomendados",
	"最新": "Novos Jogos",
	"全部": "Todos os Jogos",
	"获取类型中": "Tipo de obtenção",
	"获取具体信息中": "Obtenção de informações específicas",
	"开始": "Começar",
	"正在获取资源": "Aquisição de recursos",
	"正在努力加载中": "A tentar carregar",
	"电子": "Jogos Eletrônicos",
	"大厅": "hall",
	"游戏类型": "Plataforma de Jogos",
	"游戏标签": "Marcas do jogo",
	"错误的类型": "Tipo de jogo errado",
	"返回首页": "Voltar à página inicial",
	"正在获取游戏列表": "Obter a lista de jogos",
	"暂无游戏": "Atualmente não existem jogos disponíveis",
	"当前未登录,请先登录": "Atualmente não está logado, por favor faça login primeiro",
	"联系我们": "Atendimento ao cliente",
	"导航": "navegação",
	"配置文件信息": "Informações do perfil",
	"常用功能": "Funções de trabalho comuns",
	"充值": "Recarregar",
	"提现": "Retirada",
	"功能列表": "Lista de Funções",
	"交易": "transacção",
	"设置": "configurar",
	"修改登入密码": "Alterar a senha de autenticação",
	"修改提现密码": "Alterar a senha de retirada",
	"银行卡": "cartão bancário",
	"若您先前透由手机号或社交平台登录站点，请您直接联系客服协助设置": "Se você fez login anteriormente no site através do seu número de telefone ou plataforma de mídia social, entre em contato diretamente com o atendimento ao cliente para ajudar na configuração",
	"旧密码": "Senha antiga",
	"请输入旧密码": "Por favor introduza a sua senha antiga",
	"设定新密码": "Definir uma nova senha",
	"确认新密码": "Confirmar a senha nova",
	"确认": "confirmar",
	"下一步": "Próxima Etapa",
	"交易功能": "Função de transacção",
	"支付方式": "Forma de pagamento",
	"充值教学": "Recarregar o ensino",
	"选择渠道": "Escolha um canal",
	"存款金额": "Montante do depósito",
	"实际金额": "Montante efectivo",
	"提现币种": "Moeda de retirada",
	"提现银行卡": "Retirada do cartão bancário",
	"新增": "Adicionar",
	"提现金额": "Montante de retirada",
	"提现金额范围": "Intervalo do montante de retirada",
	"请输入金额": "Indique o montante",
	"实际到帐": "Recebimento efectivo",
	"一般手续费": "Taxas gerais de tratamento",
	"强制手续费": "Taxas obrigatórias de tratamento",
	"上一步": "Passo anterior",
	"修改成功": "Modificado com sucesso",
	"修改中": "Modificar...",
	"拼命加载中": "Carregando desesperadamente",
	"编辑登录密码": "Editar a senha de autenticação",
	"编辑提款密码": "Editar a senha de retirada",
	"如果您通过手机号码或社交平台登录网站，请联系向客户服务部门寻求帮助。": "Se você fizer login no site através do seu número de telefone ou plataforma de mídia social, entre em contato com o serviço de atendimento ao cliente para obter assistência.",
	"请输入新密码": "Introduza uma nova senha",
	"新密码不能和旧密码一致": "A nova senha não pode corresponder à senha antiga",
	"两次输入密码不一致!": "As duas senhas inseridas não correspondem!",
	"请输入提款密码": "Indique por favor a senha de retirada",
	"输入提款密码": "Indique a senha de retirada",
	"请设置新的提款密码": "Por favor, defina uma nova senha de retirada",
	"设置6位提款密码，并记住您的密码": "Defina uma senha de retirada de 6 dígitos e lembre-se de sua senha",
	"请输入新的提款密码": "Introduza uma nova senha de retirada",
	"存款": "Depósito",
	"取款": "Retirada",
	"付款方式": "Forma de pagamento",
	"存款金额": "Montante do depósito",
	"请输入金额": "Indique o montante",
	"下一步": "Passo seguinte",
	"提款金额": "Montante de Retirada",
	"提款银行卡": "Cartão bancário de levantamento",
	"请输入您的银行卡号": "Introduza o número do seu cartão bancário",
	"加载失败": "O carregamento falhou",
	"交易记录": "Registos de transacções",
	"状态": "estado",
	"已审核": "Revisado",
	"未审核": "Não auditado",
	"币种": "moeda",
	"时间": "tempo",
	"今日": "hoje",
	"近3日": "Hoje 3º",
	"近7日": "Dia 7 de hoje",
	"重置": "Repor",
	"申请时间": "Tempo de aplicação",
	"充值方式": "Método de recarga",
	"存款金额": "Montante do depósito",
	"切换语言将会刷新页面": "Mudar de idioma irá atualizar a página",
	"取消": "cancelar",
	"登录过期,是否重新登录": "Login expirou, você deseja fazer login novamente",
	"系统提示": "Prompt do sistema",
	"游戏记录": "Gravação do Jogo",
	"游戏品牌": "Marca do jogo",
	"游戏名称": "Nome do Jogo",
	"下注时间": "Tempo de aposta",
	"下注金额": "Montante da aposta",
	"输赢金额": "Montante de ganhos ou perdas",
	"新增银行卡": "Adicionar um novo cartão bancário",
	"请输入": "Por favor, introduza",
	"银行名称": "Nome do Banco",
	"账号类型": "tipo de conta",
	"收款人": "Beneficiário",
	"PIX账号": "Conta PIX",
	"请选择": "Seleccione por favor",
	"提现密码": "Senha de retirada",
	"提交": 'Enviar',
	"提现成功": 'Retirada bem sucedida',
	'提现失败': 'A retirada falhou',
	"国家": "país",
	"请选择": "Seleccione por favor",
	"请输入": "Por favor, introduza",
  "please-select-method": "Selecione a forma de pagamento",
  "lang-label": "Português",
   "app_download": "Baixar aplicativo",
   "hot": "Quente",
  	"demo": "Demonstração",
	"betRecords": "Registros de apostas",
	"agent": "Agente",
	"faq": "Faq",
	"offers": "Ofertas",
	'sign-up': 'Inscrever-se',
	'member-login': 'Login de Membro',
	'sign-in-message': 'Suporta apenas registro de conta',
	"reg-agreement": "Tenho mais de 18 anos.",


	// 新的一套
	"加载更多": "Carregar mais",
	"开始": "Play",
	// "存取款":"Depósito/Retirada",
	"存取款": "Depósito",
	"更多": "adicionar dinheiro",
	"选择您的奖金": "Seleccione o seu bónus",
	"100%,最高1500": "100% até R$1.500",
	"CASINO": "CASINO",
	"Select your lottery": "Seleccione a sua lotaria",
	"don't want a lottery": "Não quero uma lotaria.",
	"金额不得小于": "O montante não deve ser inferior a",
	"金额不得大于": "O montante não pode ser superior a",
	"加载失败": "falha",
	"活动中心": "Centro de Actividades",
	"**财富攀升-BRL的充值促销**": "**Escalada de Riqueza - Promoção de Recarga em BRL**",
	"在这个独特的活动中，我们为您提供了一个积累财富的无尽机会。无论你是初学者还是老手，每次充值都会为你带来不同级别的礼物以及更高级别的特权。": "Neste evento exclusivo, oferecemos a você uma oportunidade infinita de acumular riqueza. Seja você um novato ou um veterano, cada recarga trará a você presentes em diferentes níveis, bem como privilégios em níveis superiores.",
	"**青铜级别（青铜）**": "**Nível Ouro (GOLD)**",
	"-重新加载的总金额：1.000-5.000 BRL": "- Valor total recarregado: 1.000 - 5.000 BRL",
	"-礼品的比例从5%逐渐增加到10%": "- A proporção de presente aumenta gradualmente de 5% a 10%",
	"-第一次充值时，您将收到一份专属礼物。通往财富的大门是敞开的。每充值一次，就会收到更多的礼物。": "- Na primeira recarga, você já receberá um presente exclusivo. A porta para a riqueza está aberta. A cada recarga adicional, mais presentes virão.",
	"**银级（银级）**": "**Nível Prata (SILVER)**",
	"-重新加载的总金额：5.001-15.000 BRL": "- Valor total recarregado: 5.001 - 15.000 BRL",
	"-礼品的比例从10%逐渐增加到15%": "- A proporção de presente aumenta gradualmente de 10% a 15%",
	"-您已达到白银级别，您的财富将继续增长。充值越多，礼品比例就越高。重新加载更多，赚取更多！": "- Você alcançou o nível Prata, onde sua riqueza continua a crescer. Quanto mais você recarrega, maior será a proporção de presente. Recarregue mais, ganhe mais!",
	"**黄金级别（Gold）**": "**Nível Ouro (GOLD)**",
	"-重新加载的总金额：15.001-30.000 BRL": "- Valor total recarregado: 15.001 - 30.000 BRL",
	"-礼品的比例从15%逐渐增加到18%": "- A proporção de presente aumenta gradualmente de 15% a 18%",
	"-你正走在富有的贵族之路上。成为金牌会员后，您将收到更多慷慨的礼物。你的财富注定会兴旺发达。": "- Você está na estrada da nobreza, onde a riqueza abunda. Ao se tornar um membro Ouro, você receberá presentes mais generosos. Sua riqueza está destinada a prosperar.",
	"**白金级别（白金）**": "**Nível Platina (PLATINUM)**",
	"-随着冷却值的增加，会奖励更多的礼物": "- À medida que o valor da recarga aumenta, mais presentes são concedidos",
	"-重新加载的总金额：30.001-60.000 BRL": "- Valor total recarregado: 30.001 - 60.000 BRL",
	"-礼品的比例从18%逐渐增加到20%": "- A proporção de presente aumenta gradualmente de 18% a 20%",
	"-在白金级别，您的充值将获得更高比例的礼物。你的理财能力会变得更加卓越，并获得丰厚的回报。": "- No nível Platina, sua recarga receberá uma proporção mais alta de presentes. Seu domínio financeiro se torna ainda mais notável, com recompensas abundantes.",
	"**钻石级别（钻石）**": "**Nível Diamante (DIAMOND)**",
	"-重新加载的总金额：60.001-100.000 BRL": "- Valor total recarregado: 60.001 - 100.000 BRL",
	"-礼品比例最高，达到20%": "- A maior proporção de presente, alcançando 20%",
	"-这是荣誉的高度，是最终的选择。成为钻石会员后，您将享受最高比例的礼物，使您的财富加速增长，您的财务梦想即将实现。": "- Este é o auge de honra, a escolha máxima. Ao se tornar um membro Diamante, você desfrutará da maior proporção de presentes, levando sua riqueza a um crescimento acelerado, e seus sonhos financeiros estão prestes a se tornar realidade.",
	"不要错过这个难得的机会。攀登财富的阶梯，看着你的财富成倍增长。加入我们的“财富攀登”BRL补充促销活动，确保为实现您的财务目标提供最佳支持。财富之旅从你开始，回报不会停止增长，成功就在你身边！": "Não perca esta oportunidade incrível. Suba a escada da riqueza, veja sua riqueza multiplicar. Junte-se à nossa 'Escalada de Riqueza' na Promoção de Recarga em BRL e garanta o suporte ideal para alcançar seus objetivos financeiros. A jornada para a riqueza começa com você, as recompensas não param de crescer, o sucesso está ao seu lado!",
	"上一页": "última página",
	"下一页": "página seguinte",
	'法规与合作伙伴': 'Regulamentos e Parceiros',
	'为了注册本网站，用户必须接受一般条款和条件。如果条款和条件发生更新，现有用户可以选择在上述更新生效之前停止使用产品和服务，即在更新公布后至少两周。tambet911.com 由JajajEmmi B.V.运营，注册号为150790，地址为Abraham Mendez Chumaceiro Boulevard 03，Willemstad，Curacao。本网站由库拉索岛电子博彩公司许可和监管，许可证号为1668/JAZ。': 'Para se inscrever neste site, os usuários devem aceitar os termos e condições gerais. Se os termos e condições forem atualizados, os usuários existentes podem optar por parar de usar os produtos e serviços antes da atualização acima mencionada entrar em vigor, ou seja, pelo menos duas semanas após a atualização ser anunciada. Tambet911.com é operado por JajajEmmi B.V. com número de registro 150790 e seu endereço é Abraham Mendez Chumaceiro Boulevard 03, Willemstad, Curaçao. Este site é licenciado e regulamentado pela Curacao Island Electronic Gaming Company com número de licença 1668/JAZ.',
	'您可以使用用户名和密码登录': 'Você pode fazer login com seu nome de usuário e senha',
	'创建账户': 'Criar conta',
	'银行信息': 'Informações bancárias',
	'名称': 'Nome',
	'时间': 'Hora',
	'最小': 'Min',
	'最大': 'Máximo',
	'即时到账': 'Recebimento instantâneo',
	'选择银行': 'Select Bank',
	'银行账号': 'Número da conta bancária',
	'请输入银行账号': 'Introduza a sua conta bancária',
	'金额': 'Montante',
	'输入金额': 'Indicar o montante',
	'暂无数据': 'Actualmente não existem dados disponíveis',
	'获奖人': 'Vencedor',
	'游戏榜': 'Gráfico de Jogo',
	'新游戏榜': 'Novo Gráfico de Jogo',
	'热门游戏榜': 'Classificação Popular de Jogos',
	'电子游戏': 'Jogos electrónicos',
	'主要余额': 'Saldo principal',
	'历史记录': 'História',
	'付款名称': 'Nome do pagamento',
	'费用': 'Custo',
	'免费': 'Livre',
	'立即生效': 'Efetivamente',
	'银行选择': 'Selecção bancária',
	'银行账户': 'Conta bancária',
	'充值金额': 'Montante da recarga',
	'收款名称': 'Nome do pagamento',
	'账号类型': 'Tipo de conta',
	'收账账号': 'Número da conta de cobrança',
	'CPF号码': 'Número do CPF',
	'提现密码': 'Retirar senha',
	'请输入名称': 'Por favor insira um nome',
	'请选择类型': 'Por favor, insira o tipo de seleção',
	'请输入CPF': 'Por favor, insira o CPF',
	'请输入提现金额': 'Por favor, insira o valor do saque',
	'请输入正确的参数': 'Por favor insira os parâmetros corretos',
	"收藏夹": "Favoritos",
	"敬请期待": "Em breve",
	"用户": "Do utilizador",
	"玩家": "Jogador",	
	"时间":"Tempo",
	"赌场": "Casino",
	"体育运动": "Desporto",
	"促销": "Promo",
	"支持/法律": "Apoio/Jurídico",
	"赌场主页": "Casino Home",
	"插槽": "Slots",
	"现场赌场": "Casino ao Vivo",
	"新版本": "Novas Versões",
	"桌面游戏": "Jogo de Mesa",
	"体育之家": "Sports Home",
	"会员俱乐部": "Clube VIP",
	"优惠促销": "Promoções",
	"赌博意识": "Consciente do Jogo",
	"常问问题": "FAQ",
	"条款和条件": "Termos e Condições",
	"隐私政策": "Política de Privacidade",
	"赞助和游戏责任": "Patrocínio e responsabilidades no jogo",
	"页脚文本": "BetBlitz pretende se tornar o líder global em jogos online e apostas usando as mais recentes tecnologias blockchain, sempre colocando nossos clientes em primeiro lugar. Confiança, integridade e justiça são apenas três dos nossos principais valores.",
	
	'负责任的博彩': 'Jogo Responsável',
	'快速链接': 'Links Rápidos',
	'桌上游戏': 'Jogos de mesa',
	'二十一点': 'Blackjack',
	'扑克': 'Pôquer',
	'百家乐': 'Bacará',
	'掷骰子': 'Dados',
	'奖金': 'Bônus',
	'赌场奖金': 'Bônus de Cassinos',
	'自由旋转': 'Giro Grátis',
	'免费投注': 'Apostas Grátis',
	'信息': 'Informação',
	"": "",
	"": "",
	"": "",
	
	"老虎机游戏":"Jogos de Slots",
	"老虎机游戏":"Jogos de caça-níqueis",
	"赌场游戏":"Jogos de Cassino",
	"更多游戏":"Mais jogos",
	"搜索游戏":"Pesquisar jogos",
	"特色提供商":"Provedores em destaque",
  "Limit" : "Limite",
  "MessageCenter" : "Central de Mensagens",

  'All':'Todos',
  'Arcade': 'Fliperama',
  'Bingo': 'Bingo',
  'Card': 'Cartão',
  'Casino': 'Cassino',
  'Crash': 'Colapso',
  'Fish': 'Peixe',
  'Live': 'Ao vivo',
  'Lottery': 'Loteria',
  'Slot':'Caça-níquel',
  'Sports':'Esportes',
  'Video Game':'Jogo de vídeo',

  'cs-title': '7x24 HORAS',
	'cs-text': 'O atendimento ao cliente está disponível para solução de problemas e perguntas.',
	'cs-contact': 'Contato',


  'social-media': 'Mídias Sociais',
  'contact-us': 'Entre em contato conosco através dos seguintes',
  "install-btn": "INSTALL",

  'footer-line1': 'é operado por',
  'footer-line2': 'Endereço da empresa registrado',
  'footer-line3': 'Este produto é apenas para usuários com mais de 18 anos e é para fins de entretenimento apenas',
  'footer-line4': 'Este jogo contém compras dentro do aplicativo',
  'footer-line5': 'O fato de um jogador jogar ou ganhar em jogos de azar sociais não significa que ele ou ela ganhará em jogos de azar com dinheiro real e jogos relacionados no futuro',
  

	// Added Lines
	"popup-message": "Você quer desativar os lembretes?",

	'sign-in': 'Entrar',
	'password': 'Senha',
	'confirm-password': 'Confirmar Senha',
	'remember-me': 'Lembrar-me',
	'forgot-password': 'Esqueceu a Senha',
	"sign-in-note": "Não tem uma conta?",
	"register-note": "Já tem uma conta?",
	"register": "Cadastrar",

  "popular": "Popular",
  "promotion": "Promoção",
  "follow": "Seguir",
  "search": "Pesquisar",

  "home": "Início",
  "deposit": "Depositar",
  "withdraw": "Sacar",
  "profile": "Perfil",
  "online-cs": "Atendimento ao Cliente Online",

	"search-games": "Pesquisar Jogos",
  "results": "Resultados",

	"Activity": "Atividade",
  "Rebates": "Rebates",
  "VIP": "VIP",
  "History": "Histórico",
  "Cover": "Cobertura",

	"recharge-activity": "Atividade de Recarregamento",
  "time": "Tempo",
  "reward": "Recompensa",
  "deposit-value": "Valor do Depósito",
  'status':'Status',
  'reward-bonus-discription': "Ganhe 10R$ grátis após seu primeiro depósito de 100R$.",
  'invitaion-activity-discription': "Convide amigos e ganhe 100R$ grátis.",
  'daily-loss-activity-discription': "8% de reembolso diário.",
  'recharge-rebet-activity-discription': "  Ganhe 20% de cashback gratuitamente ao recarregar 100R$ em uma única transação",
  'user-not-eligible': "Você não está qualificado para esta recompensa",
  '不符合领取资格': "Não elegível para receber",
  'reward-claimed': "Recompensa reivindicada com sucesso!",
  '没有符合资格的充值': 'Nenhuma recarga qualificada',

	"invitation-activity": "Atividade de Convite",
  "recharge-amount": "Valor da Recarregamento",
  "spin": "Girar",
  "reward": "Recompensa",
	"bonus": "Bônus",
  'invites':'Invites',

	"daily-loss-relief-fund": "Fundo de Alívio<br>de Perdas Diárias",
  "percent": "Porcentagem",
  "amount-loss": "Perda de Valor",

	"recharge-rebate-activity": "Atividade de Rebate<br>de Recarregamento",
	"recharge-amount": "Valor do Recarregamento",
  "return-ratio": "Taxa de Retorno",
  "return-amount": "Valor do Retorno",

	"recharge-note1": "Uma recarga única de 100 reais brasileiros pode participar do evento;",
  "recharge-note2": "Cada recarga de 100 reais brasileiros ou mais é calculada de forma independente;",
  "recharge-note3": "Esta atividade requer um mínimo de 5 vezes o valor da recarga para receber recompensas;",
  "recharge-note4": "Aqueles que não cumprirem o padrão ou completarem a coleta de recompensas após o evento não poderão receber a recompensa novamente;",
  "recharge-note5": "Evite causar perdas, por favor, complete a tarefa com antecedência ou receba recompensas;",
  "recharge-note6": "Esta atividade é limitada ao comportamento normal de operação dos titulares de contas e proíbe meios técnicos como aluguel, trapaça, bots, jogos com contas diferentes, troca mútua, arbitragem, interfaces, protocolos, exploração de vulnerabilidades e controle em grupo. Caso contrário, recompensas serão canceladas, deduzidas, congeladas ou até mesmo incluídas na lista negra;",
  "recharge-note7": "Os direitos de interpretação de todas as atividades pertencem exclusivamente a esta plataforma;",

	"claim": "Reivindicar",

	'lottery-wheel': 'Roda da Sorte',
	'number-of-spin': 'Número de Giros',
	'spin': 'Girar',

	'upgrade-required': 'Atualizacao necessaria',
	'recharge': 'Recarregar',
	'betting': 'Apostas',
	'Bonus': 'Bônus',
	'Notification': 'Notificação',
	'Announcement': 'Anúncio',
	'Support': 'Suporte',
	'level': 'Nível',

	'view-data': 'Ver dados',
	'current-data': 'Dados atuais',
	'last': 'Último',
	'days': 'dias',
	'event': 'Evento',
  'notes': 'Notas',

	'rebate-funds':'Fundos de Rebate',
	'statement':'Declaração',
	'rebate':'Rebate',

	'platform-rebate':'Rebate de<br>Plataforma',
	'action':'Ação',
	'type':'Tipo',
	'amount':'Quantia',

	'record': 'Gravar',
	'recharge-note': 'Se você encontrar qualquer problema, por favor, entre em contato conosco!',
	'withdrawal-note': 'Se você encontrar qualquer problema, por favor, entre em contato conosco!',
	'online-service': 'Atendimento Online',
  'recharge-amount': 'Valor do Recarregamento',
	'withdrawal': 'Saque',
	'online-withdrawal': 'Saque Online',
	'withdrawal-method': 'Método de Saque',
	'fee': 'Taxa',
	'full-name': 'Nome Completo',
	'please-enter-your': 'Por favor, insira seu',
	'name': 'Nome',
	'collection-account-number': 'Número da Conta para Coleta',
	'withdraw-password': 'Senha para Saque',
	'phone-number': 'Número de Telefone',

	'balance': 'Saldo',
	'information-center': 'Centro de Informações',
	'order-center': 'Central de Pedidos',
	'agency-center': 'Centro de Agência',
	'exit': 'Saída',
	'bonus-amount': 'Valor do Bônus',
	'fee-amount': 'Valor da Taxa',
	'change': 'Alterar',
	'male': 'Masculino',
	'female': 'Feminino',
  'submit': 'Enviar',
	'information': 'Informação',
	'Details': 'Detalhes',
	'Fee': 'Taxa',
	'Association': 'Associação',
	'security-center': 'Centro de Segurança',
	'change-password': 'Alterar Senha',
	'financial-status': 'Status Financeiro',
	'verify-password': 'Verificar Senha',
	'bind-email-note': 'Você está vinculando seu e-mail e precisa verificar sua senha de login',
	'bind-password-note': 'Você está alterando sua senha e precisa fazer login para verificação da senha',
	'next-step': 'Próximo Passo',

	"Invite": "Convite",
  "Agent": "Agente",
  'Invitation record':'Registro de convite',
  "Invitation": "Convite",
  "Reward": "Recompensa",
  "Agency mechanism": "Mecanismo de agência",
	"Register subordinates": "Registrar subordinados",
	"my-id": "Meu ID",
  "inviter-id": "ID do Convidador",
  "ordinary-agent": "Agente Comum",
  "my-invitation-information": "Minhas informações de convite",
  "my-links": "Meus Links",
  "save-qr-code": "Salvar código QR",
  "my-invitation-record": "Meu registro de convite",
  "total-number-of-invited-people": "Total de pessoas convidadas",
  "direct-reports": "Relatórios Diretos",
  "invitation-rewards": "Recompensas de Convite",
  "invitation-total-reward": "Recompensa total de convite",
  "directly-invite-rewards": "Recompensas de convite direto",
  "indirect-invitation-reward": "Recompensa de convite indireto",
  "more": "Mais",
	"invitation-total": "Total de Convites",
  "direct-rewards": "Recompensas Diretas",
  "indirect-incentives": "Incentivos Indiretos",
	"no-agent": "Nenhum agente para exibir",
	"no-record": "Nenhum registro encontrado",
	"no-more-roll": "Não há mais rolo restante",
	"rebate-ration": "Relação de Reembolso",
  "deposit-value": "Valor do Depósito",

	"bet-on": "Apostar em",
	"settlement": "Liquidação",
	"consumption": "Consumo",
  "agent-text": "Texto do Agente",
	"reg-sub-text": "Após completar o registro, insira o número de telefone registrado do convidado, o código de convite e o UID deles para vinculá-los.",
	"your-invitation-code": "Seu código de convite",
  "UID-of-the-invitee": "UID do convidado",
  "user-does-not-exist":"USUÁRIO NÃO EXISTE",

	'no-record':'Nenhum registro encontrado',
  "reg-success": "Seu registro foi concluído com sucesso",
  "reg-failed": "Falha no registro",
  "valid-number": "Por favor, insira um número de telefone válido",
  "valid-pass2": "As senhas não coincidem",
	'pass-error':'A senha deve ter pelo menos 6 caracteres',	
	"network-error": "Erro de rede, tente novamente mais tarde",
	"fix-error": "Por favor, corrija o erro no formulário",

	'invalid_phone': 'Por favor, insira o número de celular correto.',
}
export default zh_cn



// WEBPACK FOOTER //
// ./src/utils/lang/config/zh_cn.js